import {Component, Input} from 'ng-metadata/core';

@Component({
    selector: 'prm-rapido-message-bar',
    templateUrl: 'components/search/fullView/ngrs/rapidoMessageBar/rapido-message-bar.html',
})

export class PrmRapidoMessageBar{
    @Input() msg: string;
    @Input() success: boolean;

    public getMessage(): String {
        return this.msg;
    }

    public isSuccess():boolean{
        return this.success;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/rapidoMessageBar/rapidoMessageBar.directive.ts